import { Box, TextField, Typography, TextFieldProps } from '@benchlabs/react-design-system';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type TextInputProps = TextFieldProps & {
  id: string;
  label: string;
  value?: string;
};

export const TextInput = ({ id, label, ...props }: TextInputProps): React.ReactElement => {
  const { control } = useFormContext();
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr minmax(50px, 279px)',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Typography component="label" variant="body2" htmlFor={id}>
        {label}
      </Typography>
      <Controller
        control={control}
        render={({ field }) => (
          <TextField
            id={id}
            size="small"
            fullWidth
            {...props}
            {...field}
            inputProps={{
              ...props.inputProps,
              style: { fontSize: '0.8rem' },
            }}
          />
        )}
        name={id}
      />
    </Box>
  );
};
